import template from './delegationsList.html';
import controller from './delegationsList.controller';
import './delegationsList.scss';

let delegationsListComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    openDelegationModal: '&',
    delegations: '<',
  },
  template,
  controller,
};

export default delegationsListComponent;



// WEBPACK FOOTER //
// ./client/app/components/delegationsList/delegationsList.component.js